module.exports = __webpack_public_path__ + "img/farming-news-01.c8723131.png";